module.exports = __webpack_public_path__ + "static/media/ios-log-out.64666e40.svg";